export default __webpack_public_path__ + "static/ways-to-earn-bg-mobile-9a9f1116447f2b8c9ac452d7b17c2718.webp";